var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Fuse from 'fuse.js';
import * as React from 'react';
import { AutoSizer } from 'react-virtualized';
import { EMPTY_OPTION } from './constants';
import { SelectDropdown } from './SelectDropdown';
import { SelectedOption } from './SelectedOption';
import { OptionIcon, StyledArrow, StyledSelect, Wrapper } from './styles';
import { CreateSyntheticEvent } from '../../utilities/createEvent';
import { Icon } from '../Icon';
import { InputBorder } from '../InputBorder';
var getSafeOptionValue = function (option) {
  return option.value || typeof option.value === 'number' ? option.value : undefined;
};
var buildValueMap = function (options) {
  return options.reduce(function (map, option, index) {
    var _a;
    return __assign(__assign({}, map), (_a = {}, _a[option.value] = __assign(__assign({}, option), {
      index: index
    }), _a));
  }, {});
};
var Select = /** @class */function (_super) {
  __extends(Select, _super);
  function Select(props) {
    var _this = _super.call(this, props) || this;
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    _this.dropdownRef = React.createRef();
    _this.inputRef = React.createRef();
    _this.selectRef = React.createRef();
    _this.overSelect = false;
    _this.optionSelecting = false;
    var state = {
      internalOptions: [],
      open: false,
      highlightIndex: 0,
      isFiltering: false,
      hasFocus: false,
      selectedIndex: -1,
      value: null,
      remoteRowCount: null,
      filterKeyword: undefined
    };
    if (_this.props.controlled) {
      var value = props.value,
        defaultValue = props.defaultValue,
        options = props.options;
      _this.valueMap = buildValueMap(options);
      _this.searcher = new Fuse(options.map(function (_a, index) {
        var label = _a.label;
        return {
          label: label,
          index: index
        };
      }), {
        keys: ['label'],
        id: 'index'
      });
      var selectedIndex = _this.valueMap[value] && _this.valueMap[value].index || _this.valueMap[defaultValue] && _this.valueMap[defaultValue].index || 0;
      state = Object.assign(state, {
        selectedIndex: !value && !defaultValue ? -1 : selectedIndex,
        value: !value && !defaultValue ? null : options[selectedIndex] ? options[selectedIndex] : null
      });
    }
    _this.state = state;
    _this.isRowLoadedInternal = _this.isRowLoadedInternal.bind(_this);
    _this.loadMoreRowsInternal = _this.loadMoreRowsInternal.bind(_this);
    return _this;
  }
  Select.prototype.componentDidMount = function () {
    document.addEventListener('mousedown', this.handleClickOutside);
  };
  Select.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _this = this;
    if (this.props.controlled) {
      var _a = this.props,
        value = _a.value,
        options = _a.options;
      if (options !== prevProps.options) {
        this.valueMap = buildValueMap(options);
      }
      if (value !== prevProps.value && value !== undefined) {
        var selectedOption = this.valueMap[value];
        this.setState({
          selectedIndex: selectedOption ? selectedOption.index : -1,
          value: selectedOption || null
        });
      }
    }
    if (!this.props.controlled) {
      var _b = this.state,
        filterKeyword = _b.filterKeyword,
        open_1 = _b.open,
        remoteRowCount = _b.remoteRowCount;
      var searchable = this.props.searchable;
      if (searchable && filterKeyword !== prevState.filterKeyword) {
        if (this.props.minLength > (filterKeyword || '').length) return;
        this.loadMoreRowsInternal({
          startIndex: 0,
          stopIndex: Select.BATCH_SIZE
        }, true);
      }
      if (!searchable && !remoteRowCount && !prevState.open && open_1) {
        var loadRows = this.props.loadRows;
        loadRows({
          startIndex: 0,
          stopIndex: 0
        }).then(function (_a) {
          var remoteRowCount = _a.remoteRowCount;
          return _this.setState({
            remoteRowCount: remoteRowCount
          });
        });
      }
    }
  };
  Select.prototype.componentWillUnmount = function () {
    document.removeEventListener('mousedown', this.handleClickOutside);
  };
  Select.prototype.filterOptions = function (e) {
    var _this = this;
    var filterKeyword = e.target.value;
    var highlightIndex;
    var autocomplete = this.props.controlled && this.props.autocomplete;
    if (autocomplete) {
      highlightIndex = -1;
    } else {
      var foundOption = (this.searcher ? this.searcher.search(filterKeyword || '') : [null])[0];
      highlightIndex = foundOption ? Number(foundOption) : -1;
    }
    this.setState({
      filterKeyword: filterKeyword,
      highlightIndex: highlightIndex,
      open: true
    }, function () {
      if (autocomplete && _this.props.controlled) {
        var handleFilterChange = _this.props.handleFilterChange;
        handleFilterChange && handleFilterChange(filterKeyword);
      }
    });
  };
  Select.prototype.switchFiltering = function () {
    var _a = this.state,
      selectedIndex = _a.selectedIndex,
      open = _a.open,
      isFiltering = _a.isFiltering,
      filterKeyword = _a.filterKeyword;
    this.setState({
      filterKeyword: filterKeyword || '',
      isFiltering: !isFiltering,
      highlightIndex: selectedIndex,
      open: !open
    });
  };
  Select.prototype.handleClick = function (e) {
    var _a = this.state,
      selectedIndex = _a.selectedIndex,
      open = _a.open;
    this.setState({
      open: !open,
      isFiltering: false,
      highlightIndex: selectedIndex
    });
  };
  Select.prototype.handleBlur = function (e) {
    var _this = this;
    if (e.target !== this.inputRef.current && !this.optionSelecting) {
      this.setState({
        open: false,
        isFiltering: false,
        filterKeyword: '',
        hasFocus: false
      });
      if (this.inputRef.current) {
        CreateSyntheticEvent('blur', this.inputRef.current).then(function (syntheticEvent) {
          _this.props.onBlur && _this.props.onBlur(syntheticEvent);
        });
      }
    }
  };
  Select.prototype.handleFocus = function (e) {
    var _this = this;
    if (e.target !== this.inputRef.current && this.inputRef.current) {
      CreateSyntheticEvent('focus', this.inputRef.current).then(function (syntheticEvent) {
        _this.props.onFocus && _this.props.onFocus(syntheticEvent);
      });
    }
    var searchable = this.props.searchable;
    if (searchable && !this.overSelect) {
      this.setState({
        hasFocus: true,
        isFiltering: true
      });
    } else {
      this.setState({
        hasFocus: true
      });
    }
  };
  Select.prototype.handleSelect = function (selectedIndex) {
    return __awaiter(this, void 0, void 0, function () {
      var options, value, inputRef, syntheticEvent;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // Prevent selecting disabled options
            if (selectedIndex === -1) {
              this.focus();
              return [2 /*return*/];
            }
            options = this.props.controlled ? this.props.options : this.state.internalOptions;
            value = this.props.controlled ? options[selectedIndex].value : options[selectedIndex];
            this.setState({
              selectedIndex: selectedIndex,
              value: value,
              highlightIndex: selectedIndex,
              open: false,
              isFiltering: false,
              hasFocus: false
            });
            inputRef = this.inputRef.current;
            if (!inputRef) return [3 /*break*/, 2];
            return [4 /*yield*/, CreateSyntheticEvent('change', inputRef)];
          case 1:
            syntheticEvent = _a.sent();
            inputRef.value = (options[selectedIndex].value || '').toString();
            this.props.onChange && this.props.onChange(syntheticEvent);
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };
  Select.prototype.handleKeydown = function (e) {
    var _this = this;
    var highlightIndex = this.state.highlightIndex;
    var options = this.props.controlled ? this.props.options : this.state.internalOptions;
    var keyActions = {
      40: function () {
        if (highlightIndex < options.length - 1) {
          _this.setState({
            highlightIndex: highlightIndex + 1,
            open: true
          });
        } else {
          _this.setState({
            highlightIndex: 0,
            open: true
          });
        }
      },
      38: function () {
        if (highlightIndex > 0) {
          _this.setState({
            highlightIndex: highlightIndex - 1,
            open: true
          });
        } else {
          _this.setState({
            highlightIndex: options.length - 1,
            open: true
          });
        }
      },
      27: function () {
        _this.setState({
          open: false
        });
      },
      13: function () {
        if (!options[highlightIndex].disabled) {
          _this.handleSelect(highlightIndex);
        }
      }
    };
    // keyCode is marked as not optional in Typescript, however, on https://sentry.io/organizations/moneyfarm/issues/1331459641/?project=1780331 it appears to be undefined
    var _a = e.keyCode,
      keyCode = _a === void 0 ? 0 : _a;
    if (Object.keys(keyActions).indexOf(keyCode.toString()) > -1) {
      e.preventDefault();
      e.stopPropagation();
      keyActions[keyCode]();
      return false;
    }
    return true;
  };
  Select.prototype.handleClickOutside = function (event) {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({
        open: false
      });
    }
  };
  Select.prototype.focus = function () {
    // Focus search input if exist
    if (this.selectRef.current) {
      var input = this.selectRef.current.querySelector('input');
      if (input) {
        input.focus();
      }
    }
  };
  Select.prototype.loadMoreRowsInternal = function (_a, overwrite) {
    var _this = this;
    var startIndex = _a.startIndex,
      stopIndex = _a.stopIndex;
    var loadRows = this.props.loadRows;
    var _b = this.state,
      internalOptions = _b.internalOptions,
      filterKeyword = _b.filterKeyword,
      stateHighlightIndex = _b.highlightIndex;
    this.rowsLoaded = loadRows({
      startIndex: startIndex,
      stopIndex: stopIndex,
      filterKeyword: filterKeyword
    }).then(function (_a) {
      var items = _a.items,
        remoteRowCount = _a.remoteRowCount;
      var highlightIndex = overwrite ? 0 : stateHighlightIndex;
      _this.setState({
        internalOptions: overwrite ? items : internalOptions.concat(items),
        remoteRowCount: remoteRowCount,
        highlightIndex: highlightIndex,
        selectedIndex: -1
      });
    });
    return this.rowsLoaded;
  };
  Select.prototype.isRowLoadedInternal = function (_a) {
    var index = _a.index;
    var internalOptions = this.state.internalOptions;
    return !!internalOptions[index];
  };
  Select.prototype.render = function () {
    var _this = this;
    var _a = this.state,
      open = _a.open,
      selectedIndex = _a.selectedIndex,
      hasFocus = _a.hasFocus,
      highlightIndex = _a.highlightIndex,
      filterKeyword = _a.filterKeyword,
      isFiltering = _a.isFiltering,
      stateValue = _a.value;
    var _b = this.props,
      tabIndex = _b.tabIndex,
      searchable = _b.searchable,
      type = _b.type,
      error = _b.error,
      onFocus = _b.onFocus,
      onBlur = _b.onBlur,
      onChange = _b.onChange,
      disabled = _b.disabled,
      visibleItems = _b.visibleItems,
      placeholder = _b.placeholder,
      props = __rest(_b, ["tabIndex", "searchable", "type", "error", "onFocus", "onBlur", "onChange", "disabled", "visibleItems", "placeholder"]);
    var _c = props,
      propsOptions = _c.options,
      propsValue = _c.value,
      defaultValue = _c.defaultValue,
      focusChange = _c.focusChange,
      autocomplete = _c.autocomplete,
      controlled = _c.controlled,
      bubbleDownProps = __rest(_c, ["options", "value", "defaultValue", "focusChange", "autocomplete", "controlled"]);
    var _d = this.props.controlled ? this.props : {
        value: stateValue !== null ? stateValue.value : undefined,
        options: this.state.internalOptions
      },
      value = _d.value,
      options = _d.options;
    var selectedOption = (this.props.controlled ? options[selectedIndex] : stateValue) || EMPTY_OPTION;
    var dropdownExtraProps = this.props.controlled ? {
      isSync: true
    } : {
      loadMoreRows: this.loadMoreRowsInternal,
      isRowLoaded: this.isRowLoadedInternal,
      remoteRowCount: this.state.remoteRowCount || 0,
      batchSize: Select.BATCH_SIZE,
      isSync: false
    };
    return _jsx(AutoSizer, {
      disableHeight: true,
      style: {
        width: '100%'
      },
      children: function (_a) {
        var width = _a.width;
        return _jsxs(Wrapper, {
          children: [_jsx(InputBorder, {
            disabled: disabled,
            style: {
              position: 'relative'
            },
            error: !!error,
            focus: hasFocus,
            children: _jsxs(StyledSelect, {
              disabled: disabled,
              onClick: function (e) {
                disabled ? null : searchable ? _this.switchFiltering() : _this.handleClick(e);
              },
              onBlur: function (e) {
                return disabled ? null : _this.handleBlur(e);
              },
              onFocus: function (e) {
                return disabled ? null : _this.handleFocus(e);
              },
              onKeyDown: function (e) {
                return disabled ? null : _this.handleKeydown(e);
              },
              onMouseOver: function () {
                return _this.overSelect = true;
              },
              onMouseOut: function () {
                return _this.overSelect = false;
              },
              ref: _this.selectRef,
              children: [selectedOption.icon ? React.isValidElement(selectedOption.icon) ? selectedOption.icon : _jsx(OptionIcon, {
                children: _jsx(Icon, {
                  size: 15,
                  type: selectedOption.icon
                })
              }) : null, _jsx(SelectedOption, {
                placeholder: typeof selectedOption.label === 'string' && selectedOption.label ? selectedOption.label : placeholder,
                onChange: function (e) {
                  return _this.filterOptions(e);
                },
                value: filterKeyword || '',
                isFiltering: isFiltering,
                selectedOption: selectedOption,
                onFocus: function (e) {
                  return _this.handleFocus(e);
                },
                onBlur: function (e) {
                  return !_this.overSelect ? _this.handleBlur(e) : null;
                },
                inputTabIndex: tabIndex || 0,
                readOnly: !searchable
              }), _jsx(StyledArrow, {
                children: _jsx(Icon, {
                  size: 16,
                  type: "icon-chevron-down-big"
                })
              }), _jsx("select", __assign({
                style: {
                  display: 'none'
                },
                value: value,
                onChange: function () {
                  return false;
                }
              }, bubbleDownProps, {
                ref: _this.inputRef,
                children: options.map(function (option, index) {
                  return _jsx("option", {
                    value: getSafeOptionValue(option),
                    children: option.label
                  }, index);
                })
              }))]
            })
          }), _jsx("div", {
            ref: _this.dropdownRef,
            children: _jsx(SelectDropdown, __assign({
              open: open,
              options: options,
              highlightIndex: highlightIndex,
              onSelect: function (index) {
                return _this.handleSelect(index);
              },
              onMouseOver: function () {
                return _this.optionSelecting = true;
              },
              onMouseOut: function () {
                return _this.optionSelecting = false;
              },
              width: width,
              visibleItems: visibleItems
            }, dropdownExtraProps))
          })]
        });
      }
    });
  };
  Select.BATCH_SIZE = 50;
  Select.defaultProps = {
    controlled: true,
    value: 0,
    minLength: 2,
    defaultValue: 0,
    disabled: false,
    autocomplete: false,
    onBlur: function () {},
    onChange: function () {},
    onFocus: function () {},
    visibleItems: 3,
    placeholder: '',
    searchable: false
  };
  return Select;
}(React.PureComponent);
export { Select };